import * as yup from 'yup'

const phoneRegExp = /^(?!.*[A-z])/

const PhoneSchema = yup.string()
  .matches(phoneRegExp, 'common.errors.phoneNumber.invalid')
  .min(9, 'common.errors.phoneNumber.min')

export { PhoneSchema }
